const locale = {
  'importModal.title': 'Batch Import',
  'importModal.button.upload': 'Upload File',
  'importModal.message.parseError': 'Failed to parse file',
  'importModal.table.updatedFieldName': 'Updatable Column',
  'importModal.table.fileColumnTitle': 'File Column',
  'importModal.table.previewValue': 'Data Preview',
  'importModal.table.defaultValue': 'Default Value',
  'importModal.select.placeholder': 'Please select',
  'importModal.input.placeholder': 'Please enter',
  'importModal.button.downloadTemplate': 'Download Template',
};

export default locale;
